import { render } from "./Feedback_Details.vue?vue&type=template&id=27721c5a&scoped=true"
import script from "./Feedback_Details.vue?vue&type=script&lang=ts"
export * from "./Feedback_Details.vue?vue&type=script&lang=ts"

import "./Feedback_Details.vue?vue&type=style&index=0&id=27721c5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27721c5a"

export default script